import { Card } from '@mui/material';

export const CardTotalVisitors = props => {
  return (
    <Card
      sx={{
        padding: '8px',
        textAlign: 'center',
        boxShadow: 'none',
        border: '1px solid #ccc',
      }}
    >
      <span style={{ fontSize: '14px', color: '#6b7280' }}>Total de Visitas</span>
      <br />
      <span style={{ fontSize: '32px', fontWeight: 'bold', marginBlockStart: '8px' }}>{props.totalVisitors}</span>
    </Card>
  );
};
